import { Link } from 'react-router-dom';

const RoomsPreview = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-serif">
              Comfortable Garden View Accommodations
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Our guest rooms emphasize clean, comfortable accommodations with a tropical flair. Whether you're looking for a weekend getaway or a longer stay, you'll find everything you need to enjoy the perfect Florida Keys vacation.
            </p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-slate-700">Tropical-themed rooms with modern amenities</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-slate-700">Access to beautiful swimming pool and BBQ area</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-slate-700">Minutes from world-class fishing and diving</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-slate-700">On-site sports pub and restaurant</span>
              </li>
            </ul>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/rooms"
                className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Explore Rooms
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <a
                href="https://hotels.cloudbeds.com/en/reservation/KsGpNF"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-slate-300 text-slate-700 rounded-lg font-semibold hover:border-blue-600 hover:text-blue-600 transition-colors whitespace-nowrap"
              >
                Check Availability
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/9b5c52e7dd23d238e0f17694adaf654c.png"
                alt="Ocean View Inn guest room with tropical decor and garden view"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-star-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">4.5/5</p>
                  <p className="text-sm text-slate-600">Guest Rating</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoomsPreview;
